module.exports = __webpack_public_path__ + "static/media/chart1.821b42f3.gif";